import { createAction, createAsyncThunk } from "@reduxjs/toolkit";

export const Change = createAction("change");
export const Reset = createAction("reset");
export const LoaderOverlay = createAsyncThunk(
  `merchant/overlay`,
  async (data: any) => {
    const response = data;
    return response;
  }
);
